module.exports = __webpack_public_path__ + "img/master-slide-01.0e93994d.jpg";